import { useEffect, useState } from "react";
import api from "../api";

const API = process.env.REACT_APP_API_URL;

function Receipts() {

    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");

    // 🔹 Fetch all receipt rows
    const fetchData = () => {
        api.get(`${API}/receipt-all`)
            .then(res => setData(res.data))
            .catch(err => console.log(err));
    };

    useEffect(() => {
        fetchData();
    }, []);

    // 🔍 Filter
    const filtered = data.filter(r =>
        r.name.toLowerCase().includes(search.toLowerCase()) ||
        String(r.admno).includes(search) ||
        String(r.receiptno).includes(search)
    );

    // 🔹 Group by Adm No
    const grouped = {};
    filtered.forEach(r => {
        if (!grouped[r.admno]) grouped[r.admno] = [];
        grouped[r.admno].push(r);
    });

    // 📤 Export CSV
    const handleExport = () => {
        let csv = "ReceiptNo,AdmNo,Name,FatherName,Class,Section,FeeType,Month,Amount,Concession,Payable,AmountPaid,Mode,Date\n";

        filtered.forEach(r => {
            csv += [
                r.receiptno,
                r.admno,
                r.name,
                r.fathername,
                r.class_name,
                r.section,
                r.feetype,
                r.month,
                r.amount,
                r.concession,
                r.payable,
                r.amountpaid,
                r.mode,
                new Date(r.date).toLocaleDateString("en-IN")
            ].join(",") + "\n";
        });

        const blob = new Blob([csv], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "receipts.csv";
        a.click();
    };

    // 🖨 Print
    const handlePrint = () => {
        window.print();
    };

    // ❌ Delete (puzzle)
    const handleDelete = async (id) => {

        const a = Math.floor(Math.random() * 10);
        const b = Math.floor(Math.random() * 10);

        const ans = prompt(`Solve to delete: ${a} + ${b} = ?`);

        if (parseInt(ans) !== a + b) {
            alert("Wrong answer!");
            return;
        }

        await api.delete(`${API}/payment/${id}`, {
            data: { answer: ans, a, b }
        });

        alert("Row Deleted");
        fetchData();
    };

    return (
        <div className="print-area" style={container}>

            {/* 🔹 HEADER */}
            <div style={topBar}>
                <h2>Receipts</h2>

                <div className="no-print" style={{ display: "flex", gap: "10px" }}>
                    <button onClick={handleExport} style={exportBtn}>⬇ Export</button>
                    <button onClick={handlePrint} style={printBtn}>🖨 Print</button>
                </div>
            </div>

            {/* 🔍 SEARCH */}
            <input
                placeholder="Search by Name / Adm No / Receipt No"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={searchBox}
                className="no-print"
            />

            {/* 📋 TABLE */}
            <table style={table}>
                <thead>
                    <tr>
                        <th style={th}>Receipt</th>
                        <th style={th}>FeeType</th>
                        <th style={th}>Month</th>
                        <th style={th}>Amount</th>
                        <th style={th}>Concession</th>
                        <th style={th}>Payable</th>
                        <th style={th}>Paid</th>
                        <th style={th}>Mode</th>
                        <th style={th}>Date</th>
                        <th className="no-print" style={th}>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    {Object.keys(grouped).map(admNo => {

                        const rows = grouped[admNo];
                        const name = rows[0].name;
                        const father = rows[0].fathername;
                        const cls = rows[0].class_name;
                        const section = rows[0].section;

                        return (
                            <>

                                {/* 🔹 STUDENT HEADER */}
                                <tr style={groupHeader}>
                                    <td colSpan="10" style={{ padding: "10px", fontWeight: "bold" }}>
                                        Adm No: {admNo} | {name} | Father: {father} | Class: {cls}-{section}
                                    </td>
                                </tr>

                                {/* 🔹 DATA ROWS */}
                                {rows.map((r, i) => (
                                    <tr key={i}>
                                        <td style={td}>{r.receiptno}</td>
                                        <td style={td}>{r.feetype}</td>
                                        <td style={td}>{r.month}</td>
                                        <td style={td}>₹{r.amount}</td>
                                        <td style={{ ...td, color: "orange" }}>₹{r.concession}</td>
                                        <td style={td}>₹{r.payable}</td>
                                        <td style={{ ...td, color: "green", fontWeight: "bold" }}>
                                            ₹{r.amountpaid}
                                        </td>
                                        <td style={td}>{r.mode}</td>
                                        <td style={td}>{new Date(r.date).toLocaleDateString("en-IN")}</td>

                                        <td className="no-print" style={td}>
                                            <button
                                                onClick={() => handleDelete(r.id)}
                                                style={deleteBtn}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}

                            </>
                        );
                    })}
                </tbody>
            </table>

        </div>
    );
}
const container = {
    padding: "30px",
    maxWidth: "1100px",
    margin: "auto"
};

const topBar = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px"
};

const searchBox = {
    padding: "8px",
    width: "300px",
    marginBottom: "15px",
    borderRadius: "6px",
    border: "1px solid #ccc"
};

const table = {
    width: "100%",
    borderCollapse: "collapse",
    background: "#fff"
};

const th = {
    border: "1px solid #ddd",
    padding: "10px",
    background: "#f5f5f5"
};

const td = {
    border: "1px solid #ddd",
    padding: "10px"
};

const groupHeader = {
    background: "#eef2ff"
};

const exportBtn = {
    padding: "8px 15px",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
};

const printBtn = {
    padding: "8px 15px",
    background: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
};

const deleteBtn = {
    padding: "5px 8px",
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer"
};

export default Receipts;
